<template>
<div class="form">
<a-card size="small" :title="c_title">
    <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item label="通道编码" ref="passwaycode" prop="passwaycode">
                <a-input v-if="is_vue_task" v-model="record.passwaycode" @blur=" () => {$refs.passwaycode.onFieldBlur();}" />

                <span v-else>{{record.passwaycode}}</span>
            </a-form-model-item>

            <a-form-model-item ref="passwayname" label="通道名称" prop="passwayname">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.passwayname"
                     @blur="
                        () => {
                            $refs.passwayname.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.passwayname}}</span>
            </a-form-model-item>

            <a-form-model-item label="通道类型">
                <passwayTypeSelecter v-if="is_vue_task" ref="passwaytypeID" :showAll="false" :isdisable="!is_vue_task" @passwayTypeChange="handleChange"></passwayTypeSelecter>
                <span v-else>{{record.passwaytypename}}</span>
            </a-form-model-item>
              <a-form-model-item ref="MasterSecret" label="MasterSecret" prop="mastersecret">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.mastersecret"
                     @blur="
                        () => {
                            $refs.mastersecret.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.mastersecret}}</span>
            </a-form-model-item>
              <a-form-model-item ref="AppKey" label="AppKey" prop="appkey">
                <a-input
                    v-if="is_vue_task"
                    v-model="record.appkey"
                     @blur="
                        () => {
                            $refs.appkey.onFieldBlur();
                        }
                        "
                />
                <span v-else>{{record.appkey}}</span>
            </a-form-model-item>
            <a-form-model-item label="修改信息" v-if="!is_new">
                    创建时间 ：<span>{{record.createtime}}</span>
                    创建人:<span>{{record.createuser}}</span>
                    <br>
                    更新时间: <span>{{record.updatetime}}</span>
                    更新人: <span>{{record.updatetuser}}</span>
            </a-form-model-item>
            <a-form-model-item v-show="is_vue_task"  :wrapper-col="{ span: 14, offset: 8 }" >
                <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                    保存
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>

</template>
<script>
import passwayTypeSelecter from '../../components/passwaytypeSelecter'
const m_title = {
    'add_passway':'新增通道',
    'detail_passway':'查看通道',
    'edit_passway':'编辑通道',
};


export default {
    components:{
        passwayTypeSelecter
    },
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                passwayname: [
                    { required: true, message: ' 请输通道名称 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                passwaycode:[
                    { required: true, message: ' 请输通道编码 ', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            record:{
                id:'',
                passwaycode:'',
                passwayname:'',
                passwaytype:'',
                mastersecret:'',
                appkey:'',
                passwaytypename:'',
                createtime:'',
                createuser:'',
                updatetime:'',
                updatetuser:''
            }
        };
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const { params } = this.$route;
                    
                    if(params.action == 'edit_passway'){
                        this.$store
                            .dispatch({
                                type: "mcmsmanager/updatepassway",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    this.handleCancel();
                                }
                                this.confirmLoading = false;

                            });
                    }
                    else if(params.action == 'add_passway'){
                        this.record.id = '';
                        //新增
                        this.$store
                            .dispatch({
                                type: "mcmsmanager/addpassway",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    this.handleCancel();
                                }
                                this.confirmLoading = false;
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleChange(item){
            this.record.passwaytype = item.passwaytype;
            this.record.passwaytypename = item.passwaytypename;
        },
        handleCancel() {
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
            this.record.passwaycode = 'PASSWAY-000'
        },

        getDetail(id){
            this.$store.dispatch({
                type: "mcmsmanager/querypasswayone",
                params: {
                    id:id,
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.record = {
                        ...result
                    };
                    this.$refs.passwaytypeID.handleChange(result.passwaytype)
                }
            });
        },

    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_passway";
        if (!this.is_new) {
            this.getDetail(query.id)
        }
        else{
            this.resetForm();
        }
        this.is_vue_task = params.action != 'detail_passway'
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
